import { postJwtProfile } from "../../../helpers/fakebackend_helper";

import { profileSuccess, profileError, resetProfileFlagChange } from "./reducer";

export const editProfile = (user: any) => async (dispatch: any) => {
    try {
        const response = await postJwtProfile({
            username: user.username,
            idx: user.idx,
        });

        if (response) {
            dispatch(profileSuccess(response));
        }
    } catch (error) {
        dispatch(profileError(error));
    }
};

export const resetProfileFlag = () => {
    try {
        const response = resetProfileFlagChange();
        return response;
    } catch (error) {
        return error;
    }
};